/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Epic } from 'redux-observable';
import { Tag } from '@api/model';
import { Request, Create } from '../EpicUtils';
import { GET_TAGS, getTagsFulfilled } from 'src/js/redux/actions/PortalWebsite';
import SettingsService from '../../../api/services/SettingsService';

const request: Request<Tag[]> = {
  type: GET_TAGS,
  getData: () => SettingsService.getTags(),
  processData: (tagTree) => [
    getTagsFulfilled(tagTree)
  ]
};

export const EpicGetTags: Epic<any, any> = Create(request);
